/**
 * Passwords match checker
 * Check:
 * - the password and password confirm are similar
 *
 * @param control
 * @return
 */
import { AbstractControl, ValidationErrors, Validators } from '@angular/forms';

export const MIN_SCORE = 2;

export const passwordMatch = (control: AbstractControl): ValidationErrors | null => {
  const paswd = control.root.get('password');

  if (paswd && control.root.get('repeatPassword')?.value !== paswd.value) {
    return {
      passwordMatch: false
    };
  }

  return null;
};

export function dateIntervalValidator(control: AbstractControl): ValidationErrors | null {
  const startDateValue = control.get('startDate')?.value,
    endDateValue = control.get('endDate')?.value

  if (startDateValue && endDateValue && startDateValue > endDateValue) {
    return { dateInterval: true };
  }

  return null;
}

export function emailValidator(email: string): boolean {
  const validation =  Validators.email({ value: email } as AbstractControl);

  return validation === null;
}
